import React from "react";
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table,
    Grid,
    Typography,
    CardContent,
    InputLabel
} from '@material-ui/core';
import CountUp from 'react-countup';


export default class ComponentToPrint extends React.Component {
    render() {

        // const InquiryRegistry = this.props.InquiryRegistry;
        const TransactionDetails = this.props.TransactionDetails;
        const PdfExcelGeneralDetails = this.props.PdfExcelGeneralDetails;
        const transactionTotal = this.props.transactionTotal; 
        const startDateRange = this.props.startDateRange;
        const endDateRange = this.props.endDateRange;
        const openingBalance = this.props.openingBalance;
        return (
            <div style={{backgroundColor: "white"}}>
                <h3><center><u>Inquiry Registry Report</u></center></h3>
                <div>&nbsp;</div>
                <h2><center><u>Group: {PdfExcelGeneralDetails.groupName} - Factory: {PdfExcelGeneralDetails.factoryName}</u></center></h2>
                <div>&nbsp;</div>
                <h2><center><u>From {PdfExcelGeneralDetails.fromDate} To {PdfExcelGeneralDetails.endDate}</u></center></h2>
                <div>&nbsp;</div>
                <h2><center><u>Ledger Account Name - {PdfExcelGeneralDetails.ledgerAccountName}</u></center></h2>
                <div>&nbsp;</div>
                <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                    {TransactionDetails.length >= 0 ? (
                        <CardContent>
                        <Box>
                            <div style={{ height: '8px' }} />
                            <Box>
                                <Grid container spacing={2}>
                                <Grid item xs={12} md={12}>
                                    <Grid container>
                                    <Grid item xs={6} md={4}>
                                    </Grid>
                                    <Grid item xs={1} md={1}></Grid>
                                    <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                                        <Typography variant='h6'>
                                            Dr
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                                        <Typography variant='h6'>
                                            Cr
                                        </Typography>
                                    </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Grid container>
                                    <Grid item xs={6} md={4}>
                                        <InputLabel style={{ whiteSpace: 'nowrap' }}><b>Opening Balance as at {startDateRange.toLocaleDateString()}</b></InputLabel>
                                    </Grid>
                                    <Grid item xs={1} md={1}>:</Grid>
                                    <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                                        <Typography variant='h6'>
                                        <CountUp
                                            decimals={2}
                                            separator=","
                                            end={
                                                openingBalance.totalDebit - openingBalance.totalCredit >= 0
                                                ? openingBalance.totalDebit - openingBalance.totalCredit
                                                : null
                                            }
                                            duration={0.1}
                                            />
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                                        <Typography variant='h6'>
                                        <CountUp
                                            decimals={2}
                                            separator=","
                                            end={
                                                openingBalance.totalCredit - openingBalance.totalDebit >= 0
                                                ? openingBalance.totalCredit - openingBalance.totalDebit
                                                : null
                                            }
                                            duration={0.1}
                                            />
                                        </Typography>
                                    </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Grid container>
                                    <Grid item xs={6} md={4}>
                                        <InputLabel style={{ whiteSpace: 'nowrap' }}><b>Total (Rs) From {startDateRange.toLocaleDateString()} To {endDateRange.toLocaleDateString()} </b></InputLabel>
                                    </Grid>
                                    <Grid item xs={1} md={1}>:</Grid>
                                    <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                                        <Typography variant='h6'>
                                        <CountUp decimals={2} separator=',' 
                                            end={transactionTotal.debit} duration={0.1} />
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                                        <Typography variant='h6'>
                                        <CountUp decimals={2} separator=',' 
                                            end={transactionTotal.credit} duration={0.1} />
                                        </Typography>
                                    </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <Grid container>
                                    <Grid item xs={6} md={4}>
                                        <InputLabel style={{ whiteSpace: 'nowrap' }}><b>Net Change (Rs) From {startDateRange.toLocaleDateString()} To {endDateRange.toLocaleDateString()}  </b></InputLabel>
                                    </Grid>
                                    <Grid item xs={1} md={1}>:</Grid>
                                    <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                                        <Typography variant='h6'>
                                        <CountUp decimals={2} separator=',' 
                                            end={(transactionTotal.debit - transactionTotal.credit) >= 0 ? 
                                            (transactionTotal.debit - transactionTotal.credit) : null} duration={0} />
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                                        <Typography variant='h6'>
                                        <CountUp decimals={2} separator=',' 
                                            end={(transactionTotal.credit - transactionTotal.debit) >= 0 ? 
                                            (transactionTotal.credit - transactionTotal.debit) : null} duration={0} />
                                        </Typography>
                                    </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={12} >
                                    <Grid container>
                                    <Grid item xs={6} md={4}>
                                        <InputLabel style={{ whiteSpace: 'nowrap' }}><b>To Date Balance(Rs) as at {new Date().toISOString().split('T')[0]} </b></InputLabel>
                                    </Grid>
                                    <Grid item xs={1} md={1}>:</Grid>
                                    <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                                        <Typography variant='h6'>
                                        <CountUp decimals={2} separator=',' 
                                            end={((parseFloat(openingBalance.totalDebit) + parseFloat(transactionTotal.debit)) - 
                                            (parseFloat(openingBalance.totalCredit) + parseFloat(transactionTotal.credit))) >= 0 ? 
                                            ((parseFloat(openingBalance.totalDebit) + parseFloat(transactionTotal.debit)) - 
                                            (parseFloat(openingBalance.totalCredit) + parseFloat(transactionTotal.credit))) : null} duration={0} />
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
                                        <Typography variant='h6'>
                                        <CountUp decimals={2} separator=',' 
                                            end={((parseFloat(openingBalance.totalCredit) + parseFloat(transactionTotal.credit)) - 
                                            (parseFloat(openingBalance.totalDebit) + parseFloat(transactionTotal.debit))) >= 0 ? 
                                            ((parseFloat(openingBalance.totalCredit) + parseFloat(transactionTotal.credit)) - 
                                            (parseFloat(openingBalance.totalDebit) + parseFloat(transactionTotal.debit))) : null} duration={0} />
                                        </Typography>
                                    </Grid>
                                    </Grid>
                                </Grid>
                                </Grid>
                            </Box>
                        </Box>
                        </CardContent>
                    ) : null}
                    </div>
                <div>
                    <Box minWidth={1050}>
                        <TableContainer >
                            <Table aria-label="caption table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align={'center'}>Reference No</TableCell>
                                        <TableCell align={'center'}>Date</TableCell>
                                        <TableCell align={'center'}>Description</TableCell>
                                        <TableCell align={'center'}>Cheque No</TableCell>
                                        <TableCell align={'center'}>Reg No</TableCell>
                                        <TableCell align={'right'}>Debit(Rs.)</TableCell>
                                        <TableCell align={'right'}>Credit(Rs.)</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {TransactionDetails.map((data, index) => (
                                        <TableRow key={index}>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.referenceNumber}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.date.split('T')[0]}
                                            </TableCell>
                                            <TableCell align={'left'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.description}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.chequeNumber === null ? '-' : data.chequeNumber}
                                            </TableCell>
                                            <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                {data.registrationNumber}
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            <CountUp
                                                end={data.debit}
                                                separator=","
                                                decimals={2}
                                                decimal="."
                                                duration={0.1}
                                                />
                                            </TableCell>
                                            <TableCell align={'right'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                            <CountUp
                                                end={data.credit}
                                                separator=","
                                                decimals={2}
                                                decimal="."
                                                duration={0.1}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </div>
                <div>&nbsp;</div>
                <h3><center>***** End of List *****</center></h3>
            </div>

        );
    }

}
